import "./style/index.less";
import CurrencyComponent from "./CurrencyComponent";

export default CurrencyComponent;
